import React from "react";
import InfoIcon from "@mui/icons-material/Info";
import {
  Tooltip,
  styled,
  tooltipClasses,
  Paper,
  Typography,
} from "@mui/material";
import { format } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import BadgeUnidade from "../../../../shared/components/badgeUnidade/BadgeUnidade";

// Estilizando o tooltip para ter aparência customizada
const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
    borderRadius: "8px",
    padding: "12px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
}));

const SessaoInfoTooltip = ({ procedimento }) => {
  // Formatação da data para exibição
  const formatarData = (dataString) => {
    try {
      const data = new Date(dataString);
      return format(data, "dd/MM/yyyy 'às' HH:mm", { locale: ptBR });
    } catch (e) {
      return "Data inválida";
    }
  };

  return (
    <span className="executarProcedimento__step1__lineItem">
      <span>{procedimento.sessoes.length}</span>
      <HtmlTooltip
        title={
          <Paper elevation={0} sx={{ p: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Detalhes das Sessões
            </Typography>
            {procedimento.sessoes.map((sessao, index) => (
              <div
                key={sessao._id}
                style={{
                  marginBottom: "8px",
                  borderBottom:
                    index !== procedimento.sessoes.length - 1
                      ? "1px solid #eee"
                      : "none",
                  paddingBottom: "8px",
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  Sessão {index + 1}:
                </Typography>
                <Typography variant="body2">
                  Médico: {sessao.medico.name}
                </Typography>
                <Typography variant="body2">
                  Data: {formatarData(sessao.data_inicio_execucao)}
                  {/* Onde a sessão foi executada. Um procedimento pode ter
                      sessões feitas em unidades diferentes, e quem está a
                      executar a seguinte deve saber onde as anteriores foram
                      feitas. Mesma pastilha das outras listas. */}
                  <BadgeUnidade
                    estabelecimento={sessao.estabelecimento}
                    prefixo="Executada em"
                  />
                </Typography>
                {procedimento.procedimento_completo &&
                  index === procedimento.sessoes.length - 1 && (
                    <Typography
                      variant="body2"
                      sx={{ color: "green", fontWeight: "bold", mt: 1 }}
                    >
                      Finalizado por: {sessao.medico.name}
                    </Typography>
                  )}
              </div>
            ))}
          </Paper>
        }
      >
        <InfoIcon
          fontSize="small"
          color="primary"
          sx={{
            ml: 1,
            cursor: "pointer",
            "&:hover": { color: "#1565c0" },
          }}
        />
      </HtmlTooltip>
    </span>
  );
};

export default SessaoInfoTooltip;
